import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  ResolveEnd,
  ResolveStart,
  Router,
  RouterEvent,
  RouterOutlet,
} from '@angular/router';

import { environment } from '../environments/environment';
import { ForethoughtWidgetService } from './cfo/services/forethought-widget.service';
import { AdminAlertsContainerComponent } from './core/components/admin-alerts/components/admin-alerts-container/admin-alerts-container.component';
import { HeaderWrapperComponent } from './core/components/navigation/header/header-wrapper/header-wrapper.component';
import { IconService } from './core/services/icon.service';
import { RouteHistoryService } from './core/services/route-history.service';
import { UserService } from './core/services/user.service';
import { User } from './models/user';
import { FlexComponent } from './ui-kit/flex/flex.component';
import { ProgressBarComponent } from './ui/progress-bar/progress-bar.component';
import { SidebarComponent } from './ui/sidebar/sidebar.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    HeaderWrapperComponent,
    FlexComponent,
    ProgressBarComponent,
    SidebarComponent,
    AdminAlertsContainerComponent,
    RouterOutlet,
  ],
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private routeHistoryService = inject(RouteHistoryService);
  private userService = inject(UserService);
  private iconService = inject(IconService);
  private forethoughtWidgetService = inject(ForethoughtWidgetService);

  loading = false;
  isProd = environment.production;
  user: User;

  ngOnInit(): void {
    this.userService.getUserObservable().subscribe((user) => {
      this.user = user;
    });
    this.router.events.subscribe((event: RouterEvent | Event) => this.handleRouterEvent(event));
    this.iconService.addSvgIcons();
    this.forethoughtWidgetService.init();
  }

  private handleRouterEvent(routerEvent: RouterEvent | Event): void {
    if (routerEvent instanceof ResolveStart) {
      this.loading = true;
    }

    if (
      routerEvent instanceof ResolveEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ) {
      this.loading = false;
    }

    if (routerEvent instanceof NavigationEnd) {
      this.routeHistoryService.handleUrlChange(routerEvent.urlAfterRedirects);
    }
  }
}
